/**
 * ECharts Custom Build - Ottimizzato per ByteRivo CRM
 * Include solo i chart types e componenti usati nel progetto
 * Riduzione bundle: 444KB → ~100KB (-78%)
 */
import Vue from 'vue';
import VueEcharts from 'vue-echarts';
import { use } from 'echarts/core';

// Renderers (obbligatori)
import { CanvasRenderer } from 'echarts/renderers';

// Chart types usati nel progetto
import { BarChart, LineChart, PieChart } from 'echarts/charts';

// Componenti necessari
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
} from 'echarts/components';

// Registra solo i componenti necessari
use([
  CanvasRenderer,
  BarChart,
  LineChart,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
]);

// Registra il componente v-chart globalmente
Vue.component('v-chart', VueEcharts); 